import React from 'react';
import { useQuery } from '@apollo/client';
import { Button } from '@mui/material';
import { OrgOrgUnitSelectors } from '../../shared/components/inputs/OrgOrgUnitSelectors';
import ApolloError from '../../shared/components/ApolloError';
import PageInstructions from '../../shared/components/PageInstructions';
import GET_ORGS_AND_UNITS_WITH_APPROVED_MDDAP_APPRAISAL from '../queries/getOrgsAndUnitWithApprovedMddapAppraisalQuery';
import { DATA_DOWNLOAD_TYPES } from '../../shared/constants/DataDownloadTypes';
import useDataDownload from '../hooks/useDataDownload';
import DeDuplicatedMetricImportButton from './DeDuplicatedMetricImportButton';

const PAGE_TITLE = 'Data Download';
const PAGE_DESCRIPTION =
  'Use the Download button to access all Check Point Data in the Portal. Limit the data to a subsection by using the filters below. ' +
  'To update metric classifications use the De-Duplicated Export make updates and upload via the De-Duplicated Import button.';
const DE_DUPLICATED_EXPORT_BUTTON_TEXT = 'De-Duplicated Export';
const ORG_LABEL = 'Organization Name(s)';
const OU_LABEL = 'OU Name(s)';

export const CheckPointDataDownload = () => {
  const {
    selections,
    handleSelections,
    handleDownloadClick: handleCheckPointDownloadClick,
    fileDownloadError: checkPointFileDownloadError
  } = useDataDownload(DATA_DOWNLOAD_TYPES.checkPoint);

  const {
    handleDownloadClick: handleDeDuplicatedExportClick,
    fileDownloadError: deDuplicatedExportFileDownloadError
  } = useDataDownload(DATA_DOWNLOAD_TYPES.deDuplicatedMetrics);

  const {
    data: orgsAndUnitsData,
    loading: orgsAndUnitsLoading,
    error: orgsAndUnitsError
  } = useQuery(GET_ORGS_AND_UNITS_WITH_APPROVED_MDDAP_APPRAISAL);

  const organizations = orgsAndUnitsData?.orgsAndUnitsWithApprovedMddapAppraisal || [];

  if (orgsAndUnitsError || checkPointFileDownloadError || deDuplicatedExportFileDownloadError) {
    return <ApolloError />;
  }

  return (
    <>
      <section className='page-instructions'>
        <PageInstructions title={PAGE_TITLE} description={PAGE_DESCRIPTION} />
        <div className='page-instructions-actions'>
          <Button className='primary-button' onClick={handleCheckPointDownloadClick}>
            Download Report
          </Button>

          <Button className='primary-button' onClick={handleDeDuplicatedExportClick}>
            {DE_DUPLICATED_EXPORT_BUTTON_TEXT}
          </Button>

          <DeDuplicatedMetricImportButton />
        </div>
      </section>
      <div className='data-download'>
        <section className='page-section'>
          <OrgOrgUnitSelectors
            sectionClassName='option-selector'
            organizations={organizations}
            orgSelectorProps={{
              value: selections.orgIds,
              onChange: handleSelections('orgIds'),
              label: ORG_LABEL
            }}
            orgUnitSelectorProps={{
              value: selections.orgUnitIds,
              onChange: handleSelections('orgUnitIds'),
              label: OU_LABEL
            }}
            loading={orgsAndUnitsLoading}
          />
        </section>
      </div>
    </>
  );
};
